import api from "./api";

const projectVendorsPath = "/api/v1/project-apps/vendorConfig";

export async function getWalletConfig({ messageType, activeDivisionId }) {
  const { data } = await api.get(projectVendorsPath, {
    params: {
      activeDivisionId,
      messageType,
    },
  });
  return data;
}
